import React from "react";
import { KTOKEN } from "./utils/constants";

export const LoggedContext = React.createContext({
  logged: !!localStorage.getItem(KTOKEN),
  setLogged: () => {}
});
